<div class="h-full grid w-full overflow-y-auto p-5 gap-8 grid-cols-2">
	<div class="h-full flex flex-col overflow-auto gap-2">
		<h2 class="mb-4">Forms</h2>
		<div class="min-h-0 overflow-auto flex flex-col gap-2">
			<app-container
				*ngFor="
					let genericFormTypeWithForms of genericFormsByFormType$
						| async
						| keyvalue: compareFn;
					trackBy: trackByFormType
				"
				[title]="genericFormTypeWithForms.key"
			>
				<div class="flex flex-col gap-3">
					<app-anchor
						*ngFor="
							let genericForm of genericFormTypeWithForms.value;
							trackBy: trackByGenericForm
						"
						[url]="baseRoute + '/' + genericForm.id"
						type="pill"
					>
						{{ genericForm.name }}
					</app-anchor>
				</div>
			</app-container>
		</div>
	</div>
	<div class="flex-1">
		<router-outlet></router-outlet>
	</div>
</div>
